import FormLabel from './FormLabel';

export default FormLabel;
